import { createContext } from "react";

export const MODE=createContext('dark');